import { Size, sizeToCSS } from '../../../utils/UNSAFE_size';
import { coerceArray } from '../../../utils/UNSAFE_arrayUtils';
import { boxAlignment } from './boxalignment.css';

type BoxAlignments = Parameters<typeof boxAlignment>[0];

export type BoxAlignmentProps = {
  // align?: keyof typeof alignStyles;
  align?: BoxAlignments['alignItems'];
  gap?: Size | [Size] | [Size, Size];
  // justify?: keyof typeof justifyStyles;
  justify?: BoxAlignments['justifyContent'];
};

const boxAlignmentInterpolations = {
  align: ({ align }: Pick<BoxAlignmentProps, 'align'>) =>
    align === undefined
      ? {}
      : {
          class: boxAlignment({ align: align })
        },
  justify: ({ justify }: Pick<BoxAlignmentProps, 'justify'>) =>
    justify === undefined
      ? {}
      : {
          class: boxAlignment({ justify })
        },
  // See https://developer.mozilla.org/en-US/docs/Web/CSS/gap
  gap: ({ gap }: Pick<BoxAlignmentProps, 'gap'>) => {
    if (gap === undefined) {
      return {};
    } else {
      const [rowSize, columnSize = rowSize] = coerceArray(gap) as [Size] | [Size, Size];
      return { gap: `${sizeToCSS(rowSize)} ${sizeToCSS(columnSize)}` };
    }
  }
};

export { boxAlignmentInterpolations };
